import { EndpointResponse } from 'types/api/end-point'
import {
  TeamExternalIntegration,
  ResponseBodyEvaluation,
  Predicate
} from 'types/api/services/golden-signal'
import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'
import { ENDPOINT_URLS } from 'utils/third-party'

export const dataDogEUStatusCheckIntegration: TeamExternalIntegration = {
  name: 'Datadog EU',
  type: IntegrationType.DatadogEU,
  authUrl: `${ENDPOINT_URLS.datadog_eu}v2/current_user/application_keys`,
  isPrivateNetworkIntegration: false,
  headers: [
    { key: 'DD-API-KEY', value: '', label: 'API Key' },
    {
      key: 'DD-APPLICATION-KEY',
      value: '',
      label: 'Application Key'
    }
  ],
  url: ENDPOINT_URLS.datadog_eu,
  sortIndex: 0
}

export const datadogEUMonitorRegex = new RegExp(
  '^https:\\/\\/(app|api).datadoghq.eu\\/(monitors|api/v1/monitor)\\/(.+\\d)'
)

export const datadogEUResponseBodyEvaluationConfiguration: ResponseBodyEvaluation =
  {
    op: 'AND',
    predicates: [
      {
        jpQuery: '.overall_state',
        type: 'String',
        comparator: 'EQU',
        rValue: 'OK'
      } as Predicate
    ]
  }

export function convertToDatadogEUApiUrl(url: string): string {
  if (datadogEUMonitorRegex.test(url)) {
    const isAPIUrl = datadogEUMonitorRegex.exec(url)?.[2] === 'api/v1/monitor'
    const monitorId = datadogEUMonitorRegex.exec(url)?.[3]

    if (isAPIUrl) {
      return url
    }

    if (monitorId) {
      return `https://api.datadoghq.eu/api/v1/monitor/${monitorId}`
    }
  }

  return null
}

export function getDatadogEUMonitorName(
  testEndpointResponse: EndpointResponse
): string {
  return JSON.parse(testEndpointResponse?.responseBody)?.name
}
